<div class="cyclic-treatment">

  @if (loading) {
    <p class="ct-status"><i class="fa fa-spinner fa-spin"></i> <span>{{ 'field.label.loading' | translate | async }}</span></p>
  }

  @if (errorMessage) {
    <p class="ct-error"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</p>
  }

  @if (preAuth && cyclicItems.length) {

    <ul class="ct-context">
      @if (preAuth.preAuthReferenceNumber) {
        <li><span>{{ 'field.label.preAuthReferenceNumber' | translate | async }}</span><b>{{ preAuth.preAuthReferenceNumber }}</b></li>
      }
      @if (preAuth.patientFirstName || preAuth.patient_name) {
        <li><span>{{ 'field.label.patient_name' | translate | async }}</span><b>{{ preAuth.patientFirstName || preAuth.patient_name }}</b></li>
      }
      @if (preAuth.uhId) {
        <li><span>{{ 'field.label.uhId' | translate | async }}</span><b>{{ preAuth.uhId }}</b></li>
      }
      <li><span>{{ 'field.label.biometric_count' | translate | async }}</span><b>{{ authenticationCount }}</b></li>
    </ul>

    @for (item of cyclicItems; track item.service_code) {
      <div class="ct-procedure">

        <div class="ct-procedure-head">
          <span class="ct-name">{{ procedureLabel(item) }}</span>
          <span class="ct-count">
            {{ recordedFor(item).length }} / {{ approvedFor(item) }}
            @if (wasReduced(item)) {
              <em class="ct-reduced">{{ 'field.label.cycles_reduced_by_payer' | translate | async }} {{ item.noOfCycles }}</em>
            }
          </span>
        </div>

        <div class="ct-rows">
          @for (row of rowsFor(item); track row.cycleNumber) {
            <div class="ct-row"
                 [class.captured]="row.captured"
                 [class.next]="row.next"
                 [class.locked]="row.locked">

              <span class="ct-cycle">{{ 'field.label.cycle' | translate | async }} {{ row.cycleNumber }}</span>

              @if (row.captured) {
                <span class="ct-date">{{ row.cycle.treatmentDate | dateFormat }}</span>
                <span class="ct-mode">
                  <i class="fa fa-check-circle"></i>
                  {{ row.cycle.authentication_type_display || row.cycle.authentication_type_code }}
                  @if (periodOf(row.cycle)) {
                    <em class="ct-period">{{ periodOf(row.cycle) }}</em>
                  }
                  @if (row.cycle.cyclic_doc) {
                    <i class="fa fa-paperclip ct-doc" title="{{ row.cycle.cyclic_doc_title || ('field.label.cyclic_doc' | translate | async) }}"></i>
                  }
                </span>
              } @else if (row.next) {
                <span class="ct-date">&mdash;</span>
                <span class="ct-mode ct-outstanding">{{ 'field.label.awaiting_biometric' | translate | async }}</span>
              } @else {
                <span class="ct-date">&mdash;</span>
                <span class="ct-mode">{{ 'field.label.cycle_locked' | translate | async }}</span>
              }
            </div>
          }
        </div>

        @if (canCapture(item)) {
          <div class="ct-capture">
            <span class="ct-capture-label">{{ 'field.label.capture_cycle_biometric' | translate | async }}</span>
            <div class="ct-capture-modes">
              <button type="button" class="primary-btn" (click)="capture(item, 'FINGERPRINT')">
                {{ 'field.label.fingerprint' | translate | async }}
              </button>
              <button type="button" class="secondary-btn" (click)="capture(item, 'IRIS')">
                {{ 'field.label.iris' | translate | async }}
              </button>
              <button type="button" class="secondary-btn" (click)="capture(item, 'FACE')">
                {{ 'field.label.face' | translate | async }}
              </button>
            </div>
          </div>
        } @else if (blockedReason(item)) {
          <p class="ct-blocked"><i class="fa fa-info-circle"></i> {{ blockedReason(item) }}</p>
        }

      </div>
    }
  }

  <div class="ct-actions">
    <button type="button" class="secondary-btn" (click)="close()">{{ 'button.close' | translate | async }}</button>
  </div>

</div>
